import { useLocation, useNavigate, useParams } from 'react-router-dom'
import './ServicesDetail.css'
import { Service } from '../Services/Services'
import { useContext, useEffect, useState } from 'react'
import { Button, Loader, Logo, TimedTooltip } from 'components/atoms'
import clsx from 'clsx'
import useMediaQuery from 'hook/useMediaQuery'
import { MediaTablet } from 'api/const/MediaQuery'
import { getServiceByID } from 'api/Api'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext'

export interface serviceParamsProps {
  serviceId: string,
  comeBackProfile: string
}

export const ServicesDetail = () => {
  const { serviceId, comeBackProfile } = useParams()
  const { baseUri, setErrorModal, matchFeaturedService, setLoadingModal } = useContext(AppGeneralContext)
  const tablet = useMediaQuery(MediaTablet)
  const [service, setService] = useState<Service>()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    setIsLoading(true)
    if (!serviceId) {
      return
    }

    getServiceByID(serviceId).then((res) => {
      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return
      }

      let resp = res.response?.data
      setService(resp)
      setIsLoading(false)
    })
  }, [])

  function updateServiceById() {
    setIsLoading(true)
    if (!serviceId) {
      return
    }

    getServiceByID(serviceId).then((res) => {
      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return
      }

      let resp = res.response?.data
      setService(resp)
      setIsLoading(false)
    })
  }

  const Match = (serviceId: string) => {
    setIsLoading(true)
    matchFeaturedService(serviceId);
    getServiceByID(serviceId).then((res) => {

      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return
      }

      let resp = res.response?.data
      setService(resp)
      setIsLoading(false)
      updateServiceById()
    })

  }

  function goBack(comeBackProfile: boolean) {
    if (comeBackProfile) {
      navigate("/start-up/profile")
      return
    }
    navigate("/start-up/profile/services")
  }

  return (
    <>
      <div className="coverHeight " style={{}} />
    <div className='position relative w-100 h-100 d-flex flex-column align-items-center  '>
      <div className="ì w-100 flex-column d-flex align-items-center  bg-service h-100 ">
        <img src={service?.logoUrl && service.logoUrl !== "" ? baseUri + service.logoUrl : "/logo192.png"} alt={service?.title ?? ""}
          className=' service-img transl-div ' />

        {isLoading ? <Loader /> :
          <div className={clsx('w-100 flex-column d-flex transl-div  ',
          { "outlet-max-width ps-4 pe-4": location.pathname.toLowerCase().includes(`services/`) && !tablet },
          { "ps-4 pe-4": location.pathname.toLowerCase().includes(`services/`) && tablet })}>
             <div className='w-100 flex-row d-flex flex-wrap mt-5 align-items-center'>
              <div className={clsx(" col-12   col-md-2 d-flex flex-row  align-items-center ",
              {"mb-3" : tablet})} 
              onClick={() => goBack(comeBackProfile === "true" ? true : false)}> 
              <Logo colorLogo='var(--primary)' className='back-btn' />
              <p className="p-0 ps-2 m-0 fw-bold pointer">{"Back"}</p>
              </div>
            <div className=" col-12  col-md-10  d-flex flex-row flex-wrap align-items-center">
              <div className={clsx('col-12 col-md-6',
              {"mb-2" : tablet})}>
                <h3 className="p-0 m-0">{service?.title ?? ""}</h3>
              </div>
              <div className={clsx('col-12 col-md-6 d-flex   align-items-center',
                { "justify-content-start pt-2 ": tablet },
                { "justify-content-end": !tablet })}>
                {service?.isMatched ?
                  <TimedTooltip
                    text={"Match already sent"}
                    childeren={
                      <Button background={'var(--primary)'}
                        text='MATCH FOR FREE' className={clsx('d-flex flex-row text-white justify-content-between')}
                        border={true}
                        borderColor='var(--primary)'
                        icon={
                          < Logo colorLogo='white' className='w-25 pe-2' />
                        }
                        primary
                        disabled={service?.isMatched}
                        onClick={() => { Match(service?.id ?? "") }} />
                    } /> :
                  <Button background={'var(--primary)'}
                    text='MATCH FOR FREE' className={clsx('d-flex flex-row text-white justify-content-between')}
                    border={true}
                    borderColor='var(--primary)'
                    icon={
                      < Logo colorLogo='white' className='w-25 pe-2' />
                    }
                    primary
                    disabled={service?.isMatched}
                    onClick={() => { Match(service?.id ?? "") }} />

                }
                </div>
              </div>
            </div>
            <div className='d-flex flex-row flex-wrap'>
              <div className="col-12 col-md-2 "/>
              <div className='col-12  col-md-10 d-flex flex-column'>
            <p className="p-0 m-0 text-grey text-start w-100 pt-4 text-wrap text-break">{service?.shortDescription ?? ""}</p>
            <p className="p-0 m-0 text-grey text-start w-100 pt-4 text-wrap text-break">{service?.longDescription ?? ""}</p>
            </div>
            </div>
            </div>
        }
      </div>
      
    </div>
    </>
  )
}
